import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "q-pl-md q-gutter-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el");
    const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_breadcrumbs, {
            class: "text-grey",
            "active-color": "green"
        }, {
            separator: _withCtx(() => [
                _createVNode(_component_q_icon, {
                    size: "1.5em",
                    name: "chevron_right",
                    color: "primary"
                })
            ]),
            default: _withCtx(() => [
                (!_ctx.$q.screen.lt.md)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.breadItems, (item) => {
                        return (_openBlock(), _createBlock(_component_q_breadcrumbs_el, {
                            key: item.itemId,
                            label: item.label,
                            icon: item.icon,
                            to: item.linkTo ? { name: item.linkTo } : undefined
                        }, null, 8, ["label", "icon", "to"]));
                    }), 128))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
